<p-dialog
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [(visible)]="visible"
    (onHide)="hideDialog()"
    [style]="{width: '60%', height: '700px'}">
    <ng-template pTemplate="header">
        <div class="discard-header flex">Edit Gadget Details</div>
    </ng-template>
    <div class="flex flex-wrap justify-between gap-4">

      <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
         <div class="flex flex-row justify-content-between">
            <span class="label">Product Name & ID:</span>
            <span class="value">{{product.ProductName + ' (' + product.ProductId + ')'}}</span>
         </div>
      </div>

      <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
        <div class="flex flex-row justify-content-between">
            <span class="label">Current Status:</span>
            <span class="value">{{getStatusText(product.Status)}}</span>
        </div>    
      </div>

      <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
        <div class="flex flex-row justify-content-between">
            <span class="label">Payments Made:</span>
            <span class="value">{{(product.AmountPaid | currency: 'PHP' : 'symbol' : '1.2-2') + ' (' + product.AmountPaidCount + ' of ' + product.StandardAging + ')'}}</span>
        </div>
      </div>

      <div class="flex flex-column w-full sm:w-5 md:w-5 lg:w-5">
        <div class="flex flex-row justify-content-between">
            <span class="label">Product Price:</span>
            <span class="value">{{product.Amount | currency: 'PHP' : 'symbol' : '1.2-2'  }}</span>
        </div>
      </div>

    </div>
    <ng-template pTemplate="body">
        <p-steps 
            [model]="menuItems" 
            [readonly]="true" 
            [activeIndex]="activeIndex" 
            (activeIndexChange)="onActiveIndexChange($event)" />

        <div class="pl-3 pr-3" *ngIf="activeIndex === 0">
            <p-scrollPanel [style]="{ width: '100%', height: '385px' }">
                <edit-availed-product-status
                    [productStatus]="product.Status" 
                    (isStatusInvalid)="isFormInvalid($event)"
                    (selectedStatusOutput)="getSelectedStatus($event)">
                </edit-availed-product-status>
            </p-scrollPanel>
        </div>
        <div class="pl-3 pr-3" *ngIf="activeIndex === 1">
            <p-scrollPanel [style]="{ width: '100%', height: '385px' }">
                <edit-availed-product-details 
                    (isDetailsInvalid)="isFormInvalid($event)">
                </edit-availed-product-details>
            </p-scrollPanel>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div *ngIf="activeIndex !== 0" class="float-left">
            <p-button
                [text]="true"
                label="Back"
                icon="pi pi-angle-left" 
                class="add-product-back-btn"
                (onClick)="previousStep()"/>
        </div>
        <p-button
            label="Next" 
            [disabled]="isFormNotValid[activeIndex]"
            class="add-product-next-btn"
            (onClick)="nextStep()"
          />
    </ng-template>
</p-dialog>
